import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-radio',
  styleUrl: './radio.scss',
  templateUrl: './radio.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioComponent),
      multi: true,
    },
  ],
})
export class RadioComponent implements ControlValueAccessor {
  /** Valeur représentée par ce bouton radio. */
  @Input() value = '';

  /** Libellé cliquable. */
  @Input() label = '';

  /** Texte d'aide. */
  @Input() hint = '';

  /** Nom du groupe (regroupe les radios HTML). */
  @Input() name = '';

  /** Désactive le bouton. */
  @Input() disabled = false;

  protected selected = '';

  private onChange: (value: string) => void = () => undefined;
  private onTouched: () => void = () => undefined;

  writeValue(value: unknown): void {
    this.selected = value == null ? '' : String(value);
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  protected select(): void {
    if (this.disabled) {
      return;
    }
    this.selected = this.value;
    this.onChange(this.value);
    this.onTouched();
  }
}
